import Helper from './Helper';

class ScrollToContent {
  constructor(config = {}) {
    const {
      buttonSelector
    } = config;
    this.buttons = document.querySelectorAll(buttonSelector);
    this.buttonsArray = Array.prototype.slice.call(this.buttons);
    if(this.buttons.length > 0){
      this.bindEvents();
    }
  }

  bindEvents(){
    this.buttonsArray.forEach((button, i) => {
      button.addEventListener('click', (e) => {

        let heroSection = button.closest('.ns-hero-section, .ns-hero-section-container');
        let scrollTo = heroSection.nextElementSibling;
        let isVisible = false;

        while (!isVisible) {
          if ( !(window.getComputedStyle(scrollTo).display === "none") ) {
            isVisible = true;
          } else {
            scrollTo = scrollTo.nextElementSibling;
          }
        }

        this.scrollTo(scrollTo);
      });
    });
  }


  scrollTo(element) {
    window.scroll({
      behavior: 'smooth',
      left: 0,
      top: Helper.getRealOffsetTop(element) - 150
    });
  }

}

export default ScrollToContent;
